module.exports = __webpack_public_path__ + "img/seed_info.a736fb39.png";